import React from "react";
import { DateRangePicker } from "react-date-range";
import Labelbox from "../../helpers/labelbox/labelbox";
import InsertInvitationIcon from "@material-ui/icons/InsertInvitation";
import Button from "@material-ui/core/Button";
import dateformat from "dateformat";
import "./DateRange.css";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { arSA, enUS } from 'react-date-range/dist/locale';
import Moment from 'moment';

export default class DateRangeSelect extends React.Component {
  state = {
    item: [
      {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
    ],
    onCount: 1,
    openDateRange: false,
    SelectRange: Moment(this.props.startDate ? this.props.startDate : new Date()).format("DD-MMM-YY") + "\xa0\xa0\xa0\xa0" + "-- >" + "\xa0\xa0\xa0\xa0" + Moment(this.props.endDate ? this.props.endDate : new Date()).format("DD-MMM-YY"),
    tabchange: 0,
  };

  onday = (item) => {
    if (this.state.onCount === 1) {
      this.setState({
        item: [item.selection],
        onCount: this.state.onCount + 1,
      });
    } else {
      this.setState({
        item: [item.selection],
        onCount: 1,
      });
    }
  };

  OKFUN = () => {
    // if(this.state.onCount===1){
    console.log(this.state.item, "item");
    this.props.rangeDate(this.state.item);
    var startdate = Moment(this.state.item[0].startDate).format("DD-MMM-YY")
    var enddate = Moment(this.state.item[0].endDate).format("DD-MMM-YY")
    this.setState({
      SelectRange:
        startdate + "\xa0\xa0\xa0\xa0" + "-- >" + "\xa0\xa0\xa0\xa0" + enddate,
      openDateRange: !this.state.openDateRange,
    });
    // }
  };

  CancelFun = () => {
    this.setState({
      openDateRange: !this.state.openDateRange,
    });
  };

  UNSAFE_componentWillReceiveProps(newProps) {
    console.log(newProps, "newProps");

    if (newProps.setselectedDate !== this.state.tabchange) {
      this.setState({
        item: [
          {
            startDate: new Date(),
            endDate: new Date(),
            key: "selection",
          },
        ],
        SelectRange: this.props.Rtype ? "" : Moment(this.props.startDate ? this.props.startDate : new Date()).format("DD-MMM-YY") + "\xa0\xa0\xa0\xa0" + "-- >" + "\xa0\xa0\xa0\xa0" + Moment(this.props.endDate ? this.props.endDate : new Date()).format("DD-MMM-YY"),
        tabchange: newProps.setselectedDate,
      });
    }
  }
  render() {
    console.log(this.state.item, "rangedate");
    const { t } = this.props;
    return (
      <div style={{ zIndex: "1" }}>
        <div
          className={`rangePicker_Master ${this.props.totalOrders && "totalOrderRange"
            } ${this.props.cancelledOrders && "cancelledOrders"} ${this.props.revenueRange && "revenueRange"
            }`}
        >
          {/* <div className="rangePicker_Label">{t('select_range')} :</div> */}
          <div
            className="rangePicker_InpputIconAlign"
            onClick={() =>
              this.setState({ openDateRange: !this.state.openDateRange })
            }
          >
            <Labelbox
              className="daterange_calendar"
              type="text"
              value={this.state.SelectRange}
              placeholder={
                "\xa0" +
                "Start Date" +
                "\xa0\xa0\xa0\xa0\xa0" +
                "-- >" +
                "\xa0\xa0\xa0\xa0\xa0" +
                "End Date"
              }
            />
            <InsertInvitationIcon className="rangePicker_Calendericon" />
          </div>
        </div>
        {
          this.state.openDateRange && (
            // <div className="rangePicker_positionCenter" onClick={()=>this.props.DateRange()}>
            <div className={`${this.props.dynalign} daterangeMaster`}>
              <DateRangePicker
                editableDateInputs={true}
                onChange={(item) => this.onday(item)}
                moveRangeOnFirstSelection={false}
                ranges={this.state.item}
                // showDateDisplay={false}
                months={1}
                direction="horizontal"
                dateDisplayFormat="dd-MMM-yy"
                locale={this.props.i18n.language == 'ar' ? arSA : enUS}
              />
              <div className="rangePicker_btncontainer">
                <Button
                  className="rangePicker_cancelbtn"
                  onClick={this.CancelFun}
                >
                  {t("cancel")}
                </Button>
                <Button className="rangePicker_okbtn" onClick={this.OKFUN}>
                  {t("ok")}
                </Button>
              </div>
            </div>
          )
          // </div>
        }
      </div>
    );
  }
}
